import React from "react";

import LoginOneColumn from "./LoginOneColumn";
import { debugLogPages } from "../../app/helpers/debugHelper";

const FormLogin = () => {
  debugLogPages('---> FormLogin');

  return (
    <div>
      {/*<LoginTwoColumns />*/}
      <LoginOneColumn />
    </div>
  );
};

export default FormLogin;

/*
 <div className="container h-100">
      <div className="border d-flex align-items-center justify-content-center h-100">
        <div className="col-6 mx-auto">
          <div className="card h-50 w-50 border-primary justify-content-center">
            <div className="card-body">
              <h5 className="card-title">Card title</h5>
              <p className="card-text">
                Some quick example text to build on the card title and make up
                the bulk of the card's content.
              </p>
              <a href="#" className="btn btn-primary">
                Go somewhere
              </a>
              asd
            </div>
            <form>
              <h3>Sign In</h3>
              <div className="mb-3">
                <label>Email address</label>
                <input
                  type="email"
                  className="form-control"
                  placeholder="Enter email"
                />
              </div>
              <div className="mb-3">
                <label>Password</label>
                <input
                  type="password"
                  className="form-control"
                  placeholder="Enter password"
                />
              </div>
              <div className="mb-3">
                <div className="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="customCheck1"
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="customCheck1"
                  >
                    Remember me
                  </label>
                </div>
              </div>
              <div className="d-grid">
                <button type="submit" className="btn btn-primary">
                  Submit
                </button>
              </div>
              <p className="forgot-password text-right">
                Forgot <a href="#">password?</a>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
*/

/*
<div className="border d-flex align-items-center justify-content-center h-25">
      <button type="button" className="btn btn-primary">Example button</button>
    </div>
*/

/*  <div className="container h-100">
        <div className="row align-items-center h-100">
          <div className="col-6 mx-auto">
            <div className="align-middle card card-login h-100 border-primary justify-content-center">
              <div>...card content...</div>
            </div>
          </div>
        </div>
  </div>*/

/*<div className="section is-fullheight">
      <div className="container">
        <div className="column is-4 is-offset-4">
          <div className="box">
            <form onSubmit={handleSubmit} noValidate>
              <div className="field">
                <label className="label">Email Address</label>
                <div className="control">
                  <input autoComplete="off" className={`input ${errors.email && 'is-danger'}`} type="email" name="email" onChange={handleChange} value={values.email || ''} required />
                  {errors.email && (
                    <p className="help is-danger">{errors.email}</p>
                  )}
                </div>
              </div>
              <div className="field">
                <label className="label">Password</label>
                <div className="control">
                  <input className={`input ${errors.password && 'is-danger'}`} type="password" name="password" onChange={handleChange} value={values.password || ''} required />
                </div>
                {errors.password && (
                  <p className="help is-danger">{errors.password}</p>
                )}
              </div>
              <button type="submit" className="button is-block is-info is-fullwidth">Login</button>
              <NavLink to="/about">Register</NavLink>
            </form>
          </div>
        </div>
      </div>
    </div>*/
